module.exports = __webpack_public_path__ + "static/media/3.347b6622.jpg";